import {createRouter, createWebHistory} from 'vue-router';
import {useSessionStore} from '@/stores/session';

import Login from "@/views/Login.vue";
import Main from "@/views/Main.vue";
import Devices from "@/views/Devices.vue";
import Schedules from "@/views/Schedules.vue";
import Logs from "@/views/Logs.vue";
import Partners from "@/views/Partners.vue";
import Remocons from "@/views/Remocons.vue";
import Settings from "@/views/Settings.vue";
import Posts from "@/views/Posts.vue";
import Profile from "@/views/Profile.vue";
import NotFound from "@/views/NotFound.vue";

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  // base: '/manager',
  history: createWebHistory(),
  routes: [{
    path: '/',
    redirect: '/device'
  }, {
    path: '/',
    component: Main,
    children: [{
      path: 'device',
      name: 'Devices',
      component: Devices,
    }, {
      path: 'schedule',
      name: 'Schedules',
      component: Schedules
    }, {
      path: 'log',
      name: 'Logs',
      component: Logs
    }, {
      path: 'partner',
      name: 'Partners',
      component: Partners
    }, {
      path: 'remocon',
      name: 'Remocons',
      component: Remocons
    }, {
      path: 'post',
      name: 'Posts',
      component: Posts
    }, {
      path: 'setting',
      name: 'Settings',
      component: Settings
    }, {
      path: 'profile', name: 'Profile', component: Profile
    }]
  }, {
    path: '/login', name: 'Login', component: Login
  }, {
    path: '/*',
    component: NotFound
  }]
});

router.beforeEach(async (to, from) => {
  const sessionStore = useSessionStore();
  if (to.path !== '/login' && !sessionStore.authorized)
    return {path: '/login'};

  else if (to.path === '/login' && sessionStore.authorized)
    return {path: '/'};
});

export default router;
